/**
 * Services Page
 * Full services listing
 */

import React, { useState } from 'react';
import { usePortal } from '../context/PortalContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import RequestQuoteModal from '../components/RequestQuoteModal';
import { Clock, DollarSign } from 'lucide-react';

const ServicesPage = () => {
  const { services, branding, loading } = usePortal();
  const [quoteTarget, setQuoteTarget] = useState(null);

  if (loading) {
    return (
      <div className="loading">
        <div className="loading-spinner" />
      </div>
    );
  }

  return (
    <>
      <Header />
      
      <main style={{ marginTop: '80px', minHeight: '80vh' }}>
        <section className="section">
          <div className="container">
            <div className="masthead">
              <span className="eyebrow">What we offer</span>
              <h1>Services</h1>
              <p>Professional services tailored to your needs</p>
            </div>

            {services.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#666' }}>
                No services available yet.
              </p>
            ) : (
              <div className="grid grid-2">
                {services.map(service => (
                  <div key={service.id} className="card" style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {service.primaryImage && (
                      <img
                        src={service.primaryImage}
                        alt={service.name}
                        style={{ flex: '1 1 200px', maxWidth: '200px', height: 'auto', objectFit: 'cover' }}
                      />
                    )}
                    <div className="card-content" style={{ flex: '2 1 240px' }}>
                      <h3 className="card-title">{service.name}</h3>
                      <p className="card-description">
                        {service.description}
                      </p>
                      
                      <div style={styles.meta}>
                        {service.duration && (
                          <span style={styles.metaItem}>
                            <Clock size={16} /> {service.duration} min
                          </span>
                        )}
                        {service.price > 0 && (
                          <span style={styles.metaItem}>
                            <DollarSign size={16} /> ${service.price?.toFixed(2)}
                          </span>
                        )}
                      </div>

                      <button
                        type="button"
                        onClick={() => setQuoteTarget({ type: 'service', id: service.id, name: service.name })}
                        style={{ ...styles.bookBtn, background: branding.primaryColor }}
                      >
                        Request a Quote
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />

      {quoteTarget && <RequestQuoteModal target={quoteTarget} onClose={() => setQuoteTarget(null)} />}
    </>
  );
};

const styles = {
  meta: {
    display: 'flex',
    gap: '20px',
    marginTop: '15px',
    color: '#666',
    fontSize: '0.9rem',
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
  bookBtn: {
    display: 'inline-block',
    padding: '12px 24px',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    marginTop: '15px',
    cursor: 'pointer',
  },
};

export default ServicesPage;
